import { useRoles } from "./AuthContext";

/** The roles the menu and the page chrome are drawn for. One hook so every consumer agrees. */
export function useShownRoles(): readonly string[] {
  return useRoles();
}
